import { AxiosError } from 'axios';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

export interface SkillDiscoveryErrorStore {
  error: AxiosError | undefined;
  setError: (error: AxiosError) => void;
}

export const skillDiscoveryErrorStore = create<SkillDiscoveryErrorStore>()(
  devtools(
    set => ({
      error: undefined,
      setError: (error: AxiosError) => {
        set({ error });
      },
    }),
    { name: 'Skill Discovery Error Store' },
  ),
);
